const userSettings = {
  clientFileColorCoding: {
    title: "Kundenakt farblich kennzeichnen",
    hint: "Der Hintergrund des Kundenakts wird anhand des Namens + SVNR + Geburtsdatum getönt.",
  },
  saveFailed: "Die Einstellung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
};

export default userSettings;
